export class Shipping {
  constructor (object) {
    this.address = this.setAddress(object)
    this.shippingAddress = object.address
    this.contact_details = object.address.contact_details
  }

  setAddress (object) {
    if (object.address != null) {
      return object.address.street + ' ' + object.address.street_number + '<br />' +
                object.address.neighborhood + ' ' + object.address.zipcode + '<br />' +
                object.address.city_name + ' ' + object.address.state_name + '<br />'
    }
    return ''
  }
}
